import { ChatMessageDisplay } from "../models/chat-message.model";
import { AiModelInfo } from "../models/ai-model-info.model";

export interface ChatThreadState {
  messages: ChatMessageDisplay[];
  isLoading: boolean;
  error: string | null;
}

// The top-level messages/isLoading/error are the default thread (AI assistant and AI planning pages).
// Other pages keep their own conversation under `threads`, keyed by the server thread name.
export interface AIAssistantState extends ChatThreadState {
  pendingReportId: string | null;
  modelInfo: AiModelInfo | null;
  threads: Record<string, ChatThreadState>;
}

export const initialChatThreadState: ChatThreadState = {
  messages: [],
  isLoading: false,
  error: null
};

const initialAIAssistantState: AIAssistantState = {
  ...initialChatThreadState,
  pendingReportId: null,
  modelInfo: null,
  threads: {}
};

export default initialAIAssistantState;
